import { Currency } from 'api/account';
import { HttpClient } from 'api/http-client';
import { DateType } from 'api/models';

export enum CostRateSourceType {
  Role = 'ROLE',
  User = 'USER',
}

export interface CostRateManagerBaseProps {
  sourceId: number;
  sourceType: CostRateSourceType;
}

export interface CostRate {
  costRateId: number;
  sourceId: number;
  sourceType: CostRateSourceType;
  currency: Currency;
  hourlyCostRate: number;
  createdAt?: DateType;
  createdBy?: number;
}

export interface UpdateCostRateProps extends CostRate {
  backdate?: DateType;
}

export type DeleteCostRateProps = Pick<
  UpdateCostRateProps,
  'sourceId' | 'sourceType' | 'backdate'
>;

const BASE_URL = '/cost-rates';
const USER_RATES = `${BASE_URL}/users`;
const ROLE_RATES = `${BASE_URL}/roles`;

class CostRateApiClient extends HttpClient {
  public getCostRateForUser = async (sourceId: number): Promise<CostRate> =>
    this.get(`${USER_RATES}/${sourceId}`);

  public getCostRateForRole = async (sourceId: number): Promise<CostRate> =>
    this.get(`${ROLE_RATES}/${sourceId}`);

  public getCostRate = async ({
    sourceId,
    sourceType,
  }: CostRateManagerBaseProps): Promise<CostRate> =>
    sourceType === CostRateSourceType.User
      ? this.getCostRateForUser(sourceId)
      : this.getCostRateForRole(sourceId);

  public updateCostRate = async (
    payload: UpdateCostRateProps,
  ): Promise<CostRate> =>
    this.put(
      `${
        payload.sourceType === CostRateSourceType.User ? USER_RATES : ROLE_RATES
      }/${payload.sourceId}${
        payload.backdate != null ? `?backdate=${payload.backdate}` : ''
      }`,
      payload,
    );

  public deleteCostRate = async (payload: DeleteCostRateProps): Promise<void> =>
    this.delete(
      `${
        payload.sourceType === CostRateSourceType.User ? USER_RATES : ROLE_RATES
      }/${payload.sourceId}${
        payload.backdate != null ? `?backdate=${payload.backdate}` : ''
      }`,
    );
}

export const CostRateApi = new CostRateApiClient();
